import { render } from "./OfferIPA.vue?vue&type=template&id=0c833286&scoped=true"
import script from "./OfferIPA.vue?vue&type=script&lang=js"
export * from "./OfferIPA.vue?vue&type=script&lang=js"

import "./OfferIPA.vue?vue&type=style&index=0&id=0c833286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c833286"]])

export default __exports__